import React from "react";
import MobileWrapper from '../../layouts/MobileWrapper';
import { Grid } from 'antd-mobile';
import { Icon } from 'antd';
import { push } from 'react-router-redux';
import { store } from '../../store/store';
import { connect } from 'react-redux';
import './style.css';

class MobileAppCenter extends React.Component {


	render() {
		const { mobileUserInfo } = this.props.user
        let navList = [], i=0;
        if(mobileUserInfo && mobileUserInfo.Menus.length !== 0){
            mobileUserInfo.Menus.forEach(v=>{
                if(v.icon === "app" && v.children.length !== 0){
                    v.children.forEach(list=>{
                        navList[i]={
                            icon: (<Icon type={list.icon} />),
                            text: list.name,
                            path: list.path
                        }
                        i++;
                    })
                }
            })
        }
		// const navList = [{
		// 	icon: (<Icon type="credit-card"/>),
		// 	text: '我的薪资',
		// 	path:'/mobile/mobile-my-salary-list'
		// }, {
		// 	icon: (<Icon type="solution"/>),
		// 	text: '公司制度',
		// 	path:'/mobile/mobile-announcement'
		// }]
		return (
			<div className="approvalCenter">
				<div className="sub-title">应用中心</div>
	    		<Grid data={navList} hasLine={false} onClick={_el =>store.dispatch(push(_el.path))} />
			</div>
		)
	}
}

// export default MobileWrapper(MobileAppCenter);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileAppCenter));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileAppCenter.js